// extracted by mini-css-extract-plugin
export default {"text":"noData_text__+8bUX"};